export default function WhyKaya() {
  const benefits = [
    {
      icon: 'ri-settings-3-line',
      title: 'Profesyonel Operasyon',
      description: 'Yemek hizmetinin düzenli şekilde planlanması ve yürütülmesi.',
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Hijyen Odaklı Üretim',
      description: 'Profesyonel mutfak süreçlerine uygun üretim yaklaşımı.',
    },
    {
      icon: 'ri-time-line',
      title: 'Zamanında Hizmet',
      description: 'İşletmelerin çalışma düzenine uygun servis planlaması.',
    },
    {
      icon: 'ri-user-settings-line',
      title: 'İhtiyaca Özel Çözüm',
      description: 'Standart paket yerine işletmenin ihtiyacına göre hizmet modeli.',
    },
    {
      icon: 'ri-team-line',
      title: 'Farklı Sektörlere Hizmet',
      description: 'Fabrika, şantiye, ofis, okul, set ve organizasyonlara yönelik çözümler.',
    },
  ];

  return (
    <section id="neden" className="py-16 md:py-24 bg-background-50">
      <div className="w-full px-4 md:px-6 lg:px-8 max-w-6xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="reveal w-full lg:w-2/5">
            <div className="rounded-2xl overflow-hidden shadow-lg">
              <img
                src="https://readdy.ai/api/search-image?query=Professional%20catering%20chef%20in%20white%20uniform%20and%20black%20apron%20plating%20fresh%20food%20in%20modern%20commercial%20kitchen%20stainless%20steel%20equipment%20bright%20hygienic%20environment%20editorial%20photography&width=800&height=1000&seq=why-kaya-1&orientation=portrait"
                alt="Profesyonel catering ekibi"
                className="w-full h-80 lg:h-[500px] object-cover"
              />
            </div>
          </div>
          <div className="reveal w-full lg:w-3/5">
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl text-foreground-950 leading-tight mb-10">
              NEDEN KAYA CATERING?
            </h2>
            <div className="space-y-6">
              {benefits.map((benefit) => (
                <div key={benefit.title} className="flex gap-4 items-start">
                  <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-500/10 border border-primary-500/20 flex-shrink-0">
                    <i className={`${benefit.icon} text-xl text-primary-600`}></i>
                  </div>
                  <div>
                    <h3 className="font-heading text-lg md:text-xl text-foreground-950 mb-1">
                      {benefit.title}
                    </h3>
                    <p className="font-body text-foreground-600 text-sm md:text-base leading-relaxed">
                      {benefit.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}